import { render } from "./QuienSoy.vue?vue&type=template&id=0fad58ea&scoped=true"
import script from "./QuienSoy.vue?vue&type=script&lang=js"
export * from "./QuienSoy.vue?vue&type=script&lang=js"

import "./QuienSoy.vue?vue&type=style&index=0&id=0fad58ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fad58ea"]])

export default __exports__